import React, { FC, useState } from "react";
import { Form, Formik, FormikHelpers } from "formik";
import { InputField } from "./InputField";
import { FrontPasswordService, RequestResetQuery } from "lib/service/client/FrontPasswordService";
import * as Yup from "yup";
import { RegisterButton1 } from "../../Form/RegisterButton1";
import { useRouter } from "next/router";
import { ValidationErrorV2 } from "lib/service/BaseClientService";
import { FrontFormErrorArea } from "../../../common/FrontFormErrorArea";
import { FrontErrorMessageArea } from "../../../common/FrontErrorMessageArea";

type Props = {
  onSuccess: () => void;
};
export const FrontPasswordResetRequestForm: FC<Props> = (props: Props) => {
  const [error, setError] = useState<string>("");
  const [validationError, setValidationError] = useState<ValidationErrorV2>({});
  const router = useRouter();
  const onSubmit = async (resetRequestQuery: RequestResetQuery, { setSubmitting }: FormikHelpers<RequestResetQuery>): Promise<void> => {
    const service = new FrontPasswordService(router);
    await service
      .requestReset(
        resetRequestQuery,
        () => {
          props.onSuccess();
        },
        setValidationError,
        setError
      )
      .finally(() => {
        setSubmitting(false);
      });
  };
  return (
    <Formik validationSchema={Schema} initialValues={initialValues} onSubmit={onSubmit}>
      {({ isSubmitting }): React.ReactNode => (
        <Form style={{ margin: "20px 0" }}>
          <FrontErrorMessageArea message={error} />
          <FrontFormErrorArea validationError={validationError} />
          <InputField name={"email"} label={"メールアドレス"} />
          <RegisterButton1 disabled={isSubmitting} type={"submit"} text={"送信"} />
        </Form>
      )}
    </Formik>
  );
};

const initialValues: RequestResetQuery = {
  email: "",
};

const Schema = Yup.object().shape({
  email: Yup.string()
    .max(100, "100文字以下にしてください")
    .email("メールアドレスの形式にしてください。")
    .required("メールアドレスは必須項目です"),
});
